import React, { Component } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import Accordion from '@vfgroup-oneplatform/foundation/Components/Timeline/Accordion/Accordion';

import OrderProgressProps from '../../Screens/OrderProgress/OrderProgress.context';
import styles from '../../Screens/OrderProgress/OrderProgress.styles';
import TimelineCard from '../TimelineCard/TimelineCard';

class Timeline extends Component {
  static contextType = OrderProgressProps;

  getSectionContainerStyle = (_, index) => {
    const { theme } = this.context;

    const hasRedBorder = index < this.props.activeStepIndex;
    const isFinal = this.context.timeline.length === index + 1;

    return [
      styles.sectionContainer(theme),
      ...(hasRedBorder ? [styles.withRedBorder(theme)] : []),
      ...(isFinal ? [styles.withTransparentBorder] : []),
    ];
  };

  renderHeader = (step, index, isActive) => {
    const { theme } = this.context;
    const isNew = index > this.props.activeStepIndex;

    return (
      <View style={styles.header}>
        {this.renderCircle(index, isActive)}

        <VFText
          style={[
            styles.headerText,
            isNew && { color: theme.colors.subtitle },
            isActive && styles.activeHeaderText,
          ]}
          i18nKey={step.title}
        />
      </View>
    );
  };

  renderCircle = (index, isActive) => {
    const { theme } = this.context;
    const isNew = index > this.props.activeStepIndex;

    return (
      <View
        style={[
          isActive && styles.activeCircle(theme),
          isNew && styles.newCircle(theme),
          !isActive && !isNew && styles.completedCircle(theme),
        ]}
      >
        {isActive && <View style={styles.activeInnerCircle(theme)} />}
      </View>
    );
  };

  render() {
    return (
      <Accordion
        touchableProps={{ underlayColor: 'transparent' }}
        sections={this.context.timeline}
        activeSections={[this.props.activeStepIndex]}
        renderHeader={this.renderHeader}
        renderContent={step => <TimelineCard step={step} />}
        renderSectionContainerStyle={this.getSectionContainerStyle}
        onSectionContainerLayout={() => {}}
      />
    );
  }
}

Timeline.propTypes = {
  activeStepIndex: PropTypes.number.isRequired,
};

export default Timeline;
